"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.previewFile = void 0;
const immer_1 = require("immer");
const action_constants_1 = require("../../../shared/store/action_constants");
const defaultState = {
    datasheetId: undefined,
    recordId: undefined,
    fieldId: undefined,
    activeIndex: -1,
    cellValue: [],
    editable: true,
    onChange: () => { },
    disabledDownload: false,
};
exports.previewFile = (0, immer_1.produce)((state = defaultState, action) => {
    switch (action.type) {
        case action_constants_1.SET_PREVIEW_FILE:
            return Object.assign({}, action.payload);
        case action_constants_1.SET_PREVIEW_FILE_CELL_ACTIVE:
            state.cellValue = action.payload;
            return state;
        case action_constants_1.SET_PREVIEW_DEFAULT_ACTIVE:
            return defaultState;
        default:
            return state;
    }
}, defaultState);
//# sourceMappingURL=preview_file.js.map